import React from 'react';
import { useParams } from 'react-router-dom';

import {
  useFilteredRescheduleClasses,
  useGetSbatGroupListQuery,
} from 'features/classCreation';
import ErrorLayout from 'components/ErrorLayout';
import Field from 'components/Field';
import RescheduleClassesViewStageTable from '../RescheduleClassesViewStageTable';

export default function RescheduleClassesView() {
  const { superBatchId } = useParams();
  const { data } = useGetSbatGroupListQuery(Number(superBatchId));
  const sbatGroups = data.data;
  const filteredSbatGroups = useFilteredRescheduleClasses(sbatGroups);

  if (filteredSbatGroups.length > 0) {
    return (
      <Field label="Reschedule Classes">
        <RescheduleClassesViewStageTable sbatGroups={filteredSbatGroups} />
      </Field>
    );
  } else {
    return (
      <ErrorLayout
        message="No upcoming classes are there!"
        className="bold"
      />
    );
  }
}
